import React, { useEffect, useState, useRef } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty, NSchange, parseClasses } from '../../lib/ep.js';

import { SquaredButton } from './ActionButton';
import ActionLink from './ActionLink';
import ButtonCollection from './ButtonCollection.js';
import ImageUploader, { AutoPostImageUploader } from './ImageUploader';
import VideoUploader from './VideoUploader';
import FieldLabel from './FieldLabel';

const MediaUploader = ({ model, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const getInitialType = () => {
		if(props.videoField && isNotEmpty(model, props.videoField)) {
			return 'video';
		}

		if(props.imageField && isNotEmpty(model, props.imageField)) {
			if(model[props.imageField].indexOf('winner_cup') > -1) return false;
			return 'image';
		}

		return false;
	};

	const [ type, setType ] = useState(getInitialType());
	const [ image, setImage ] = useState(props.image);

	const uploader_ref = useRef(false);

	useEffect(() => {
		if(props.image == image) return;
		setImage(props.image);
	}, [ props.image ]);

	if(model == undefined) return null;

	let classname = props?.classname ?? 'input gui_mixed_media';
	classname = parseClasses(classname, props._class, 'mediauploader');

	const photo = NSchange(model, props.imageField);
	const video = NSchange(model, props.videoField);

	const has_photo = (props.imageField && photo != undefined && photo != '') ? true : false;
	const has_video = (props.videoField && video != '') ? true : false;
	
	const Component = (props.auto_url != undefined) ? AutoPostImageUploader : ImageUploader;

	if(type == 'image') {
		return (
			<div>
				<Component
					{...props}
					model={model}
					name={props.imageField}
					image={image}
					onRef={(ref) => { uploader_ref.current = ref }}
					autotranslate={false}
					small_input={true}
					display_custom_dragging_instructions="Upload file"
				>
					{(has_photo) ? (
						<span>{i18n("Media")}</span>
					) : (
						<ActionLink
							onClick={() => setType(false)}
						>Media</ActionLink>
					)}
					&nbsp;&gt; {i18n("Image")}
				</Component>
			</div>
		)
	}

	if(type == 'video') {
		return (
			<div>
				<VideoUploader
					{...props}
					model={model}
					name={props.videoField}
					_autoplay={props?.autoplayField ?? false}
					value={props.video}
					autotranslate={false}
				>
					{(has_video) ? (
						<span>{i18n("Media")}</span>
					) : (
						<ActionLink
							onClick={() => setType(false)}
						>Media</ActionLink>
					)}
					&nbsp;&gt; {i18n("Video")}
				</VideoUploader>
			</div>
		)
	}

	return (
		<div onDragEnter={() => setType('image')}>
			<div class={classname}>
				<ButtonCollection>
					<SquaredButton
						icon='knk-picture'
						onClick={() => setType('image')}
						aria-label="Add image"
					/>

					<SquaredButton
						icon='knk-video'
						aria-label="Add video"
						onClick={() => setType('video')}
					/>
				</ButtonCollection>

				<FieldLabel
					{...props.label_props}
					name={props.name}
					autotranslate={props.autotranslate}
				>{props?.children ?? "Add media"}</FieldLabel>
			</div>
		</div>
	);
};

export default injectIntl(MediaUploader);